import { render, staticRenderFns } from "./condiciones-generales.vue?vue&type=template&id=08645525&"
import script from "./condiciones-generales.vue?vue&type=script&lang=js&"
export * from "./condiciones-generales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports